import { render, staticRenderFns } from "./StackedChart.vue?vue&type=template&id=0e22721c&scoped=true"
import script from "./StackedChart.vue?vue&type=script&lang=js"
export * from "./StackedChart.vue?vue&type=script&lang=js"
import style0 from "./StackedChart.vue?vue&type=style&index=0&id=0e22721c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22721c",
  null
  
)

export default component.exports